<script setup lang="ts">
import AdSlot from '../components/AdSlot.vue';
import { AD_SIZE_PRESETS } from '../config/ads';
</script>

<template>
  <div class="content-page">
    <section class="content-hero">
      <p class="page-badge">Contato</p>
      <h1>Fale com o VemChuva Brasil</h1>
      <p class="hero-lead">
        Quer sugerir melhorias, reportar um erro ou falar sobre parcerias?
        Responderemos o quanto antes com orientações claras.
      </p>
      <div class="page-meta">
        <span>Tempo médio de resposta: até 2 dias úteis</span>
        <span><a href="mailto:contato@vemchuvabrasil.com">contato@vemchuvabrasil.com</a></span>
      </div>
    </section>

    <AdSlot
      :sizes="AD_SIZE_PRESETS.top"
    />

    <section class="content-section">
      <h2>Formas de contato</h2>
      <div class="content-grid two">
        <article class="content-card">
          <h3>Email direto</h3>
          <p>Envie sua mensagem para <a href="mailto:contato@vemchuvabrasil.com">contato@vemchuvabrasil.com</a>. Inclua cidade/estado e, se for um bug, horário aproximado e navegação usada.</p>
          <a class="link-button" href="mailto:contato@vemchuvabrasil.com">Enviar email</a>
        </article>
        <article class="content-card">
          <h3>O que podemos ajudar</h3>
          <ul>
            <li>Correção de dados climáticos ou alertas exibidos.</li>
            <li>Dúvidas sobre privacidade, anúncios e consentimento.</li>
            <li>Parcerias com mídia, defesa civil ou projetos educacionais.</li>
          </ul>
        </article>
      </div>
    </section>

    <section class="content-section">
      <h2>Checklist para agilizar suporte</h2>
      <ul class="highlight-list">
        <li>Cidade consultada e horário do problema.</li>
        <li>Dispositivo e navegador usado.</li>
        <li>Capturas de tela (se possível) e passos para reproduzir.</li>
      </ul>
    </section>

    <AdSlot
      :sizes="AD_SIZE_PRESETS.middle"
    />

    <section class="content-section">
      <h2>Transparência</h2>
      <p>Seguimos as políticas do Google AdSense e nossa <a href="/politica-de-privacidade">Política de Privacidade</a>. Se você notar conteúdo que possa violar essas regras, avise para avaliarmos imediatamente.</p>
    </section>
  </div>
</template>
